import react, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getValueFromResource, dropDownSelectionStyles } from '../../../common/timeLiveFunction';
import fetchAPI from '../../../common/fetchAPI';
import { ShowToast } from '../../../common/Toastr';
import { reloadProjectTaskSummary } from '../TasksSlice';
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";

const MoveTask = ({ isOpen, accountProjectTaskId, accountProjectTaskName, projectName, closeModal }: any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { maxMenuHeight } = useAppSelector((state) => state.globalState);
    const [projectResponse, setProjectResponse] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isShowError, setIsShowError] = useState(false);
    const [projectValue, setProjectValue] = useState(0);
    const params = useParams();
    const accountId = localStorage.getItem('accountId');
    const accountEmployeeId = localStorage.getItem('accountEmployeeId');

    useEffect(() => {
        renderTimesheetFilter();
    }, []);

    const renderTimesheetFilter = async () => {
        const response = await fetchAPI('api/Projects/', 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            json.map((item: any) => {
                item.value = item.AccountProjectId;
                item.label = item.ProjectName;
            });
            json.unshift({ value: 0, label: 'All' });
            setProjectResponse(json.filter((x: any) => x.value != Number(params.AccountProjectId)));
        }
        setIsLoading(false);
    }

    const onProjectChange = (data: any) => {
        if (data.value != 0) {
            setIsShowError(false);
        } else {
            setIsShowError(true);
        }
        setProjectValue(data.value);
    }

    const moveTask = async () => {
        if (projectValue != 0) {
            setIsShowError(false);
            const object = {
                "AccountProjectId": projectValue,
                "MoveFromAccountProjectId": params.AccountProjectId,
                "AccountEmployeeId": accountEmployeeId,
                "IsMoved": true
            }
            try {
                ShowSwalWithConfirmation('Are you sure you want to move this task?', "")
                    .then(async (result) => {
                        if (result) {
                            const response = await fetchAPI(`api/V2/Tasks/MoveTask/${accountProjectTaskId}/${accountId}`, 'POST', object, true);
                            const json = await response.json();
                            if (json) {
                                if (Number(json.StatusCode) == 200) {
                                    ShowToast('Success', json.message, "success", "toast-top-right");
                                    closeModal();
                                    navigate(`/accountprojectsummary/${projectValue}`, { replace: true });
                                    dispatch(reloadProjectTaskSummary(true));
                                    // if (params.AccountProjectTaskId != undefined) {
                                    //     navigate(`/accountprojecttasksummary/${projectValue}/${accountProjectTaskId}`);
                                    // } else {
                                    //     navigate(`/accountprojectsummary/${projectValue}`);
                                    // }
                                }
                                else {
                                    ShowToast('error', json.message, "error", "toast-top-right");
                                }
                            }
                        }
                    })
                    .catch((error) => {
                    });

            } catch (error) {

            }
        } else {
            setIsShowError(true);
        }
    }

    return (
        <div className="modal drawer-overlay" tabIndex={-1} id="attendanceModal" data-bs-backdrop="false" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                        <h5 className="modal-title mainHeading">{'Move Task'}</h5>
                        <div
                            className='btn btn-sm btn-icon btn-active-color-primary'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={closeModal}
                        >
                            <KTIcon iconName='cross' className='fs-1' />
                        </div>
                    </div>
                    <div className='modal-body pb-15 px-5 px-xl-5' >
                        {isLoading ? <div className="d-flex justify-content-center align-items-center">
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                <span className='spinner-border spinner-border-md ms-2 mt-12'></span>
                            </span>
                        </div> :
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="d-flex align-items-center mb-1">
                                        <a className="text-muted fw-bold me-2 fs-2">{accountProjectTaskName}</a>
                                    </div>
                                    <div className="breadcrumb breadcrumb-separatorless fs-7 my-0">
                                        <a className="text-gray-500 fs-8">
                                            {getValueFromResource('Project Name', dispatch, t)}
                                        </a>
                                        <span className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></span>
                                        <span className="breadcrumb-item text-muted me-2 fs-6">{projectName}</span>
                                    </div>
                                    <hr></hr>
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {getValueFromResource('Select Project', dispatch, t)}
                                    </label>
                                    <Select
                                        value={projectResponse.filter((x: any) => x.value == projectValue)}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="projectList"
                                        onChange={(e) => onProjectChange(e)}
                                        options={projectResponse}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                    {isShowError && <div style={{ paddingRight: 5 }}><p className="errorMsg">{'Project Name is required'}</p></div>}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2"
                            id="kt_OffCanvas"
                            onClick={closeModal}
                        >
                            {getValueFromResource('Cancel', dispatch, t)}
                        </button>
                        <button
                            className='btn btn-sm btn-primary'
                            type='button'
                            data-kt-element='send'
                            onClick={() => {
                                moveTask();
                            }}
                        >
                            {getValueFromResource('Move Task', dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MoveTask